import React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import { HOMEPAGE_FEATURE_TOUR, TYPE_PLAGIARISM } from '@chegg-wt/core/constants/plusTab'
import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import { Config } from '@chegg-wt/core/config'
import { PlusTabType, PlusTabInfo } from '@chegg-wt/core/types/core'
import * as Styled from './styled'

export interface Props {
  tabInfo: PlusTabInfo
  onUserClickCTA: (origin: string) => void
}

export const PlusTabPanel: React.FunctionComponent<Props> = ({
  tabInfo: { imgFilename, alt, to, header, context, dataTestId, type },
  onUserClickCTA,
}) => {
  const handleClick = (e: React.SyntheticEvent) => {
    e.preventDefault()
    onUserClickCTA(type)
    if (Config.shouldOpenInNewTab && type === TYPE_PLAGIARISM) {
      window.open(to, '_blank')
    } else {
      window.location.href = to
    }
  }

  return (
    <Styled.Container>
      <Styled.Img
        data-test={`${dataTestId}-image`}
        src={publicAssetUrl(imgFilename)}
        alt={alt}
      />
      <Styled.Info>
        <Styled.Header data-test={`${dataTestId}-header`}>{header}</Styled.Header>
        <Styled.Context data-test={`${dataTestId}-context`}>{context}</Styled.Context>
        <Styled.RedirectButton
          onClick={handleClick}
          href={to}
          data-test={`${dataTestId}-button`}
        >
          Get started
        </Styled.RedirectButton>
      </Styled.Info>
    </Styled.Container>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onUserClickCTA: (type: PlusTabType) =>
    dispatch(userClick({ origin: `${HOMEPAGE_FEATURE_TOUR}-${type}` as const })),
})

export default connect(null, mapDispatchToProps)(PlusTabPanel)
